import React from 'react';
import { motion } from 'framer-motion';
import '../../styles/Benefits.css';

const Benefits = () => {
  const benefits = [
    {
      id: '01',
      title: 'Fast',
      description: 'Get essentials in minutes, not hours or days. No more waiting around for your package to arrive.'
    },
    {
      id: '02',
      title: 'Convenient',
      description: 'Enjoy easy ordering in your favorite apps, real-time tracking down to the second, and precision drone delivery right to your home.'
    },
    {
      id: '03',
      title: 'Eco friendly',
      description: 'With delivery at an all-time high, Wing drones take cars off the road, easing congestion and reducing environmental impact.'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -30 },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <section className="benefits-section" id="benefits">
      <div className="container">
        <motion.div 
          className="section-header text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <a href="#benefits" className="section-link">Benefits</a>
        </motion.div>

        <div className="benefits-container">
          <motion.div 
            className="benefits-list"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {benefits.map((benefit) => (
              <motion.div 
                key={benefit.id} 
                className="benefit-item"
                variants={itemVariants}
              >
                <div className="benefit-number">{benefit.id}</div>
                <h3 className="benefit-title">{benefit.title}</h3>
                <p className="benefit-description">{benefit.description}</p>
              </motion.div>
            ))}
          </motion.div>

          <motion.div 
            className="benefits-image"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            {/* This will be replaced with an actual image in production */}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
